export default {
  handbookDocument: "hrmis/handbook",
  readhandbook: "hrmis/handbook/save",
  allReadhandbooks: "hrmis/handbook/hasRead",
};
